module.exports = __webpack_public_path__ + "img/Pic_Support-1.f0d1c1c7.jpg";